import { Card, Grid, Stack } from "@mui/material";
import ByzTitleBox from "src/components/core-components/ByzTitleBox";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import { useTranslate } from "src/locales";
import { NutritionalRiskScoreFormData } from "../models/types";

interface MainAssessmentProps {
    formData: NutritionalRiskScoreFormData;
    onChange: (key: string, value: any) => void;
}

export const MainAssessment = ({ formData, onChange }: MainAssessmentProps) => {
    const { t } = useTranslate();

    const deteriorationItems = [
        { label: t("nutritional-risk-score.nutritione"), key: 'NORMAL_NUTRITION' },
        { label: t("nutritional-risk-score.there-mounths"), key: 'WEIGHT_LOSS_ONE_MONTHS' },
        { label: t("nutritional-risk-score.two-mounths"), key: 'WEIGHT_LOSS_TWO_MONTHS' },
        { label: t("nutritional-risk-score.one-mounths"), key: 'WEIGHT_LOSS_TREE_MONTHS' }
    ];

    const diseaseItems = [
        { label: t("nutritional-risk-score.requirements"), key: 'NORMAL_NUTRITION_REQUIREMENT' },
        { label: t("nutritional-risk-score.fracture"), key: 'DISEASE_INTENSITY_ONE' },
        { label: t("nutritional-risk-score.major"), key: 'DISEASE_INTENSITY_TWO' },
        { label: t("nutritional-risk-score.trauma"), key: 'DISEASE_INTENSITY_TREE' }
    ];

    return (
        <Card sx={{ marginBottom: "5px" }}>
            <ByzTitleBox title={t("nutritional-risk-score.main-assessment")} />
            <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid item xs={12} md={6}>
                    <Card variant="outlined" sx={{ p: 2 }}>
                        <ByzTitleBox title={t("nutritional-risk-score.deterioration")} />
                        <Stack spacing={1} mt={1}>
                            {deteriorationItems.map((item) => (
                                <Grid container key={item.key} alignItems="center">
                                    <Grid item xs={10}>
                                        <ByzMuiTypography variant="body2">{item.label}</ByzMuiTypography>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <ByzMuiCheckBox
                                            checked={Number(formData[item.key]) === 1}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                const isChecked = e.target.checked;
                                                deteriorationItems.forEach(di => {
                                                    const value = di.key === item.key ? (isChecked ? 1 : 0) : 0;
                                                    onChange(di.key, value);
                                                });
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            ))}
                        </Stack>
                    </Card>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Card variant="outlined" sx={{ p: 2 }}>
                        <ByzTitleBox title={t("nutritional-risk-score.dieses")} />
                        <Stack spacing={1} mt={1}>
                            {diseaseItems.map((item) => (
                                <Grid container key={item.key} alignItems="center">
                                    <Grid item xs={10}>
                                        <ByzMuiTypography variant="body2">{item.label}</ByzMuiTypography>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <ByzMuiCheckBox
                                            checked={Number(formData[item.key]) === 1}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                const isChecked = e.target.checked;
                                                diseaseItems.forEach(di => {
                                                    const value = di.key === item.key ? (isChecked ? 1 : 0) : 0;
                                                    onChange(di.key, value);
                                                });
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            ))}
                        </Stack>
                    </Card>
                </Grid>
            </Grid>

            <Grid container spacing={2} sx={{ p: 2, backgroundColor: '#f9f9f9', borderRadius: 1, m: 2, width: 'calc(100% - 32px)' }}>
                <Grid item xs={4}>
                    <ByzMuiTypography fontWeight={700}>{t("nutritional-risk-score.nutritione-score")}</ByzMuiTypography>
                    <ByzMuiTypography sx={{ border: '1px solid #ccc', p: 1, borderRadius: 1, mt: 1, textAlign: 'center' }}>
                        {formData.NUTRITIONAL_SCORE}
                    </ByzMuiTypography>
                </Grid>
                <Grid item xs={1} sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'center', pb: 2 }}>+</Grid>
                <Grid item xs={3}>
                    <ByzMuiTypography fontWeight={700}>{t("nutritional-risk-score.illness-score")}</ByzMuiTypography>
                    <ByzMuiTypography sx={{ border: '1px solid #ccc', p: 1, borderRadius: 1, mt: 1, textAlign: 'center' }}>
                        {formData.DISEASE_SCORE}
                    </ByzMuiTypography>
                </Grid>
                <Grid item xs={1} sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'center', pb: 2 }}>=</Grid>
                <Grid item xs={3}>
                    <ByzMuiTypography fontWeight={700}>{t("nutritional-risk-score.main-score")}</ByzMuiTypography>
                    <ByzMuiTypography sx={{ border: '1px solid #ccc', p: 1, borderRadius: 1, mt: 1, textAlign: 'center', fontWeight: 'bold' }}>
                        {formData.ASSESSMENT_SCORE}
                    </ByzMuiTypography>
                </Grid>
            </Grid>
        </Card>
    );
};
